import instantsearch from 'instantsearch.js';
import {liteClient as algoliasearch} from 'algoliasearch/lite';
import {hits,configure} from 'instantsearch.js/es/widgets';
import { connectSearchBox } from 'instantsearch.js/es/connectors';

/**
 * Initializes the search bar functionality.
 */
const searchBar = () => {
    // Algolia
    if (window.algolia === undefined) {
        return;
    }
    const {
        application_id: appId = '',
        search_api_key: apiKey = ''
    } = window.algolia;
    if (!appId || !apiKey) {
        return;
    }
    const index = 'wp_searchable_posts';
    // Search Client
    const searchClient = algoliasearch(
      appId,
      apiKey,
    );
    const search = instantsearch({
        searchClient: searchClient,
        indexName: index,
        searchFunction(helper) {
            const query = helper.state.query;
            if (query && query.trim() !== '') {
                // Trigger search
                helper.search();
            } else {
                hideResults();
            }
        },
        future: {
            preserveSharedStateOnUnmount: true,
            persistHierarchicalRootCount: true,
        },
    });

    /**
     * Initializes algolia autocomplete.
     */
    function searchInit() {
        search.addWidgets([
            configure({
                hitsPerPage: 999,
                distinct: 1,
                facetFilters: [
                    ['post_type_label:Posts', 'post_type_label:Events', 'post_type_label:Pages']
                ],
            }),
            getCustomSearchBox(),
            getHits(),
        ]);
        search.start();
        search.on('render', renderLinks);
    }

    /**
     * jQuery object representing the search bar element.
     * @type {JQuery<HTMLElement>}
     */
    const searchBar = $('.m-search-bar');

    /**
     * jQuery object representing the search bar inner wrapper element.
     * @type {JQuery<HTMLElement>}
     */
    const searchBarInnerWrapper = $('.m-search-bar__inner-wrapper');

    /**
     * jQuery object representing the autocomplete element.
     * @type {JQuery<HTMLElement>}
     */
    // const algoliaAutocomplete = $('.algolia-autocomplete');
    /**
     * @type <HTMLElement>
     */
    const popularSearchesContainer = document.querySelector('.js-autocomplete-popular-searches');
    /**
     * @type <HTMLElement>
     */
    const linksContainer = document.querySelector('.js-autocomplete-total-results');
    /**
     * @type <HTMLElement>
     */
    const resultsContainer = document.querySelector('.js-autocomplete-results');
    // const buttonsBar = $('.o-header-1__buttons-bar');
    const closeButton = $('.js-close-search');

    /**
     * jQuery object representing the slide-out element.
     * @type {JQuery<HTMLElement>}
     */
    const slideOut = $('.m-slide-out');

    /**
     * jQuery object representing the hamburger button.
     * @type {JQuery<HTMLElement>}
     */
    const hamburger = $('.js-hamburger');

    /**
     * Flag indicating whether the search bar is active.
     * @type {boolean}
     */
    let isSearchBarActive = searchBar.hasClass('m-search-bar--active');

    /**
     * Flag indicating whether the slide-out is active.
     * @type {boolean}
     */
    let isSlideOutActive = slideOut.hasClass('m-slide-out--active');
    const body = $('body');

    /**
     * Closes the slide-out if it is active.
     */
    const closeSlideOut = () => {
        if (isSlideOutActive) {
            slideOut.removeClass('m-slide-out--active');
            hamburger.removeClass('is-active'); // Close the hamburger
            // Remove body scroll lock only if no other modal is active
            if (!$('.js-slide-out').hasClass('m-slide-out--active')) {
                body.removeClass('h-scroll-lock');
            }
            isSlideOutActive = false; // Update flag
        }
    };

    /**
     * Toggles the search bar visibility and behavior.
     */
    const toggleSearchBar = () => {
        // Check if the search bar is currently visible
        if (!isSearchBarActive) {
            // Logic to show the search bar
            $('.js-header-search-toggle').addClass('a-button-search--active');
            searchBar.slideDown(500, () => {
                searchBar.addClass('m-search-bar--active');
                $('body').addClass('h-scroll-lock');
                // buttonsBar.addClass('opacity-0 invisible');
                // if (algoliaAutocomplete.css('display') === 'block') {
                //     algoliaAutocomplete.css('display', 'none');
                // }
                $('.m-search-bar__search-field').focus();
                searchInit();
                isSearchBarActive = true; // Update the flag here after showing the search bar
            });
        } else {
            // Logic to hide the search bar
            closeSearchBar();
        }
    };

    /**
     * Handles the keyup event of the search field.
     */
    const handleSearchFieldKeyup = () => {
        const searchField = $('.m-search-bar__search-field');
        const popularSearches = $('.m-popular-searches');
        const searchContainer = searchField.closest('.m-search-bar--1');

        if (searchField.val().length) {
            popularSearches.css('display', 'none');
            searchContainer.addClass('m-search-bar--focus');
        } else {
            popularSearches.css('display', 'block');
            searchContainer.removeClass('m-search-bar--focus');
        }
    };

    /**
     * Handles closing the search bar when clicking outside or tabbing away.
     * @param {Event} e - The event object (either mouseup or keyup).
     */
    const handleCloseEvent = (e) => {
        // Check for mouseup specific conditions
        if (
          e.type === 'mouseup' &&
          !searchBarInnerWrapper.is(e.target) &&
          searchBarInnerWrapper.has(e.target).length === 0
        ) {
            closeSearchBar();
        }
        // Check for keyup and specific key (Tab)
        else if (e.type === 'keyup' && e.key === 'Tab') {
            const activeElement = document.activeElement; // Get the currently focused element
            // Check if the new focused element is outside the searchBar
            if (
              !$(searchBarInnerWrapper).has(activeElement).length &&
              !$(searchBarInnerWrapper).is(activeElement)
            ) {
                setTimeout(closeSearchBar, 250);
            }
        }
    };

    /**
     * Closes the search bar and performs related DOM manipulations.
     */
    const closeSearchBar = () => {
        if (searchBar.hasClass('m-search-bar--active')) {
            // Close Algolia autocomplete dropdown
            // if (algoliaAutocomplete.css('display') === 'block') {
            //     algoliaAutocomplete.css('display', 'none');
            // }

            searchBar.slideUp(500, () => {
                searchBar.removeClass('m-search-bar--active');
                $('body').removeClass('h-scroll-lock');
                // buttonsBar.removeClass('opacity-0 invisible');
                isSearchBarActive = false; // Update search bar active state
                search.dispose();
            });
        }
    };

    // Click event for search toggle button
    $('.js-header-search-toggle').on('click', () => {
        // Close the slide-out if active
        closeSlideOut();
        toggleSearchBar();
    });

    // Click event for close search button
    closeButton.on('click', () => {
        closeSearchBar();
    });

    // Click event for hamburger button
    hamburger.on('click', () => {
        // Close the search bar if active
        if (isSearchBarActive) {
            closeSearchBar();
        }

        // Toggle the slide-out
        if (isSlideOutActive) {
            closeSlideOut();
        } else {
            slideOut.addClass('m-slide-out--active');
            hamburger.addClass('is-active');
            body.addClass('h-scroll-lock');
            isSlideOutActive = true; // Update the flag
        }
    });

    $('.m-search-bar__search-field').keyup(handleSearchFieldKeyup);
    $(document).on('mouseup', handleCloseEvent);
    $(document).on('keyup', handleCloseEvent);

    function getCustomSearchBox() {
        // Retrieve the complete HTML from your WordPress template.
        const autocompleteTemplate = wp.template('autocomplete-search-input');

        // Render function for the custom search box.
        const renderFn = (renderOptions, isFirstRendering) => {
            const { query, refine } = renderOptions;
            const container = document.querySelector('.js-autocomplete-searchbox');

            // Render the complete HTML template with the current query.
            container.innerHTML = autocompleteTemplate({ query });

            // Select the input element using the provided selector.
            const inputEl = container.querySelector('.ais-SearchBox-input');
            if (!inputEl) {
                console.error('Input element not found: .ais-SearchBox-input');
                return;
            }

            const form = container.querySelector('.js-algolia-autocomplete-form')
            if (form) {
                form.addEventListener('submit', event => {
                    event.preventDefault();
                });
            }

            // Always attach the event listener, since the input element is re-rendered each time.
            let debounceTimer;
            inputEl.addEventListener('input', event => {
                clearTimeout(debounceTimer);
                if (event.target.value) {
                    debounceTimer = setTimeout(() => {
                        refine(event.target.value);
                        showResults();
                    }, 500);
                } else {
                    hideResults();
                }
            });
            inputEl.focus();

            // Optionally update the input's value on subsequent renders if needed.
            if (!isFirstRendering) {
                inputEl.value = query;
            }
        };

        // Create the custom search box widget using the render function.
        const customSearchBox = connectSearchBox(renderFn);
        return customSearchBox({
            container: document.querySelector('.js-autocomplete-searchbox'),
        });
    }


    /**
     * Hits Widget
     * @return {Object}
     */
    function getHits() {
        // Retrieve the compiled template from the script with id "tmpl-autocomplete-post-suggestion"
        const autocompleteTemplateItem = wp.template('autocomplete-suggestion-default');
        const autocompleteTemplateItemEmpty = wp.template('autocomplete-empty');

        return hits({
            container: '.js-autocomplete-results',
            cssClasses: {
                root: ['aa-dropdown-menu'],
                item: ['aa-suggestion'],
            },
            templates: {
                item(hit, { html, components }) {
                    // Pass the hit data as "data" to the template
                    return html`${autocompleteTemplateItem(hit)}`;
                },
                empty(hit, { html, components }) {
                    // Pass the hit data as "data" to the template
                    return html`${autocompleteTemplateItemEmpty(hit)}`;
                },
            },
        });
    }

    /**
     * Renders links list at the bottom of the dropdown
     */
    function renderLinks() {
        if (!linksContainer) {
            return;
        }

        const { nbHits = 0 } = search?.helper?.lastResults || {};
        const queryStr = search?.helper?.state.query || '';

        let linksBlockHtml = ''
        if (nbHits > 1) {
            linksBlockHtml = `${nbHits} Results for "${queryStr}"`;
        }
        linksContainer.innerHTML = linksBlockHtml;
    }

    function showResults() {
        popularSearchesContainer.classList.add('hidden');
        linksContainer.classList.remove('hidden');
        resultsContainer.classList.remove('hidden');
    }

    function hideResults() {
        popularSearchesContainer.classList.remove('hidden');
        linksContainer.classList.add('hidden');
        resultsContainer.classList.add('hidden');
    }
};

export default searchBar;
